// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"d9PirwDkTFeTmc-qi39K3","badgeIcon":"_2gZ8Oly-ztLkbnGpI8TRuF"};